var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mpm_tooltip mpm-util-text-overflow-2"},[_c('a-tooltip',[_c('template',{slot:"title"},[_vm._v(_vm._s(_vm.title || _vm.content))]),_vm._v(" "+_vm._s(_vm.content)+" ")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }